module.exports = __webpack_public_path__ + "static/media/Sprchovy_gel_s_CBD_retina.d51b1be6.jpg";